<script setup lang="ts">
/** ROND/RONS 공용 — 지명자(nominator) 개인/법인 표. 스코프는 상위 DocScope 가 주입(인물별). */
import CddVarField from '../../aura/agm/cdd/CddVarField.vue';
import '../../aura/agm/docs/agmDoc.css';
</script>

<template>
  <div>
    <p class="doc-p"><b>For Nominator who are individuals</b> (to be filled only if there is a nominee):</p>
    <table class="cdd-tbl reg-tbl">
      <tbody>
        <tr><td class="reg-l">Full name</td><td><CddVarField field-key="ind_nominator_full_name" label="Full name" /></td></tr>
        <tr><td class="reg-l">Aliases, if any</td><td><CddVarField field-key="ind_nominator_aliases" label="Aliases" /></td></tr>
        <tr><td class="reg-l">Residential address</td><td><CddVarField field-key="ind_nominator_residential_address" label="Residential address" /></td></tr>
        <tr><td class="reg-l">Nationality</td><td><CddVarField field-key="ind_nominator_nationality" label="Nationality" /></td></tr>
        <tr><td class="reg-l">Identity card / passport number</td><td><CddVarField field-key="ind_nominator_id_no" label="NRIC/Passport" /></td></tr>
        <tr><td class="reg-l">Date of birth</td><td><CddVarField field-key="ind_nominator_date_of_birth" label="DOB" /></td></tr>
        <tr><td class="reg-l">Email address</td><td><CddVarField field-key="ind_nominator_email" label="Email" /></td></tr>
        <tr><td class="reg-l">Mobile phone number</td><td><CddVarField field-key="ind_nominator_mobile" label="Mobile" /></td></tr>
        <tr><td class="reg-l">Date person becomes a nominator</td><td><CddVarField field-key="ind_nominator_became_date" label="Became date" /></td></tr>
        <tr><td class="reg-l">Date person ceased to be a nominator</td><td><CddVarField field-key="ind_nominator_ceased_date" label="Ceased date" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p" style="margin-top:12px"><b>For Nominators which are legal entities</b> (to be filled only if there is a nominee):</p>
    <table class="cdd-tbl reg-tbl">
      <tbody>
        <tr><td class="reg-l">Name</td><td><CddVarField field-key="ent_nominator_name" label="Name" /></td></tr>
        <tr><td class="reg-l">UEN issued by the Registrar, if any</td><td><CddVarField field-key="ent_nominator_uen" label="UEN" /></td></tr>
        <tr><td class="reg-l">Registered office address</td><td><CddVarField field-key="ent_nominator_registered_office_address" label="Registered office" /></td></tr>
        <tr><td class="reg-l">Legal form of the legal entity</td><td><CddVarField field-key="ent_nominator_legal_form" label="Legal form" /></td></tr>
        <tr><td class="reg-l">Email address</td><td><CddVarField field-key="ent_nominator_email" label="Email" /></td></tr>
        <tr><td class="reg-l">Contactable phone / landline number</td><td><CddVarField field-key="ent_nominator_phone" label="Phone" /></td></tr>
        <tr><td class="reg-l">Jurisdiction & statute of formation</td><td><CddVarField field-key="ent_nominator_jurisdiction" label="Jurisdiction" /></td></tr>
        <tr><td class="reg-l">Name of corporate entity register (if applicable)</td><td><CddVarField field-key="ent_nominator_register_name" label="Register name" /></td></tr>
        <tr><td class="reg-l">Identification / registration number on that register</td><td><CddVarField field-key="ent_nominator_register_id" label="Register ID" /></td></tr>
        <tr><td class="reg-l">Date person becomes a nominator</td><td><CddVarField field-key="ent_nominator_became_date" label="Became date" /></td></tr>
        <tr><td class="reg-l">Date person ceased to be a nominator</td><td><CddVarField field-key="ent_nominator_ceased_date" label="Ceased date" /></td></tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
.reg-tbl { width: 100%; border-collapse: collapse; margin: 4px 0; }
.reg-tbl td { border: 1px solid #d3dbe6; padding: 5px 8px; vertical-align: top; }
.reg-l { width: 46%; background: #f7f9fc; font-weight: 600; color: #42506a; }
</style>
